module.exports = __webpack_public_path__ + "img/1795.634b4760.gif";